import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=48d7d9da&scoped=true"
import script from "./curriculum.vue?vue&type=script&lang=js"
export * from "./curriculum.vue?vue&type=script&lang=js"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=48d7d9da&prod&scoped=true&lang=css"
import style1 from "./curriculum.vue?vue&type=style&index=1&id=48d7d9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d7d9da",
  null
  
)

export default component.exports